export enum AddToCartModeType {
  Add = "add",
  Update = "update",
}
